
<div>
  <button *ngIf="showAdd" (click)="onAdd()" [disabled]="disableAdd" cy-data="add" mat-icon-button
          matTooltip="{{addTooltip ? addTooltip : 'Add'}}">
    <mat-icon [svgIcon]="disableAdd ? 'add_disabled' : 'add'"
              class="icon-display"></mat-icon>
  </button>
  <button *ngIf="showEdit" (click)="onEdit()" [disabled]="disableEdit" cy-data="edit" mat-icon-button
          matTooltip="{{editTooltip ? editTooltip : 'Edit'}}">
    <mat-icon [svgIcon]="disableEdit ? 'edit_disabled' : 'edit'"
              class="icon-display"></mat-icon>
  </button>
  <button *ngIf="showDelete" (click)="onDelete()" [disabled]="disableDelete" cy-data="delete" mat-icon-button
          matTooltip="{{deleteTooltip ? deleteTooltip : 'Delete'}}">
    <mat-icon [svgIcon]="disableDelete ? 'delete_disabled' : 'delete'"
              class="icon-display"></mat-icon>
  </button>
  <button *ngIf="showRefresh" (click)="onRefresh()" cy-data="refresh" mat-icon-button matTooltip="Refresh">
    <mat-icon class="icon-display"
              svgIcon="refresh"></mat-icon>
  </button>
</div>
